import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_RED } from "../../../config/constants";

const Track5CRed = ({ state, workState, onLabelClick }) => (
	<g id="Track5CRed" transform="translate(1803.000000, 506.000000)" className="track">
		<path
			d="M11,5.68434189e-14 C4.17993549,18.290173 7.50058754,38.820583 19.7386929,54.0282287 L68,114 L68,114"
			id="line" stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
			strokeWidth={tracksWidth} strokeLinecap="round"/>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track5CRed')}
			coords="10.000000, 41.955581"
			text="5C"
			textCoordsX="10.402832"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
		/>
	</g>
);

Track5CRed.propTypes = trackPropTypes;

export default Track5CRed;
